// extracted by mini-css-extract-plugin
module.exports = {"flex":"_33wM-","inline":"MVkEx"};